import type { ActionListActionFieldsFragment, EventListEventFieldsFragment } from "@/graphql";
import type { EventFilter, ActionFilter, UserId } from "../FilterTypes";
import CreatorFilterUI from "../ui/CreatorFilterUI.vue";
import CreatorFilterBadge from "../ui/badges/CreatorFilterBadge.vue";
import store from "@/store";

export default class CreatorFilter implements EventFilter, ActionFilter {
  constructor(
    public readonly creators: UserId[],
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = CreatorFilterBadge;

  static readonly UI = CreatorFilterUI;

  isEventActive(event: EventListEventFieldsFragment) {
    const isAllowedtoSeeIdeaCreator =
      store.getters["login/hasAccessRight"]("hlp.hideResponsible") ?? false;
    const isActive = (() => {
      return (
        this.creators.includes(event.owner?.id ?? -1) &&
        (event.__typename !== "HLPIdea" ||
          isAllowedtoSeeIdeaCreator ||
          event.owner?.id === store.getters["login/userId"])
      );
    })();
    return this.isNegated ? !isActive : isActive;
  }

  isActionActive(action: ActionListActionFieldsFragment) {
    const isActive = (() => {
      return this.creators.includes(action.assignee?.id ?? -1);
    })();
    return this.isNegated ? !isActive : isActive;
  }
}
